// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/components/ui/checkbox.tsx (base-ui Checkbox root: `checked`, `onCheckedChange`,
// `disabled`, `aria-label`, `className`; a 16px square with the primary fill when checked).
// Wraps:   Signal DS `Checkbox` (same 16px square, brand fill when checked).
// Overrides: PM's base-ui `onCheckedChange(checked, eventDetails)` is called with the DS boolean only — every PM billing
// call site reads the first argument alone. `indeterminate` and `id` pass through. PM's root is `flex` (block level,
// exactly 16 tall); the DS wrapper is `inline-flex`, which sits on the text baseline and stretches a 16px line to 19
// inside a table cell, so the wrapper is made `flex` here (tailwind-merge: the later class replaces `inline-flex`).
import { forwardRef } from 'react';
import { Checkbox, type CheckboxProps } from '@scripsteam/scrips-signal-ds';
import { cn } from '@/lib/utils';

export type BridgeCheckboxProps = CheckboxProps;

export const BridgeCheckbox = forwardRef<HTMLButtonElement, BridgeCheckboxProps>(function BridgeCheckbox(
  { className, ...props },
  ref,
) {
  return <Checkbox ref={ref} className={cn('flex', className)} {...props} />;
});
